// extracted by mini-css-extract-plugin
module.exports = {"code":"BlogCodeWithLink_code__BJZaE","nextContainer":"BlogCodeWithLink_nextContainer__D2MBx"};